import { createLoadingScreen } from "../DomUtilities/ElementsCreator";
import openErrorModal from "../Error/ErrorModal";
import { deleteUser, fetchDeleteUserModal } from "../HTTPRequests/UserRequests";
import Mediator from "../Utilities/Mediator";

export default class DeleteUserModal {
	loadingScreen: HTMLElement;
	userId: string;
	editModalDiv: HTMLDivElement;

	constructor(userId: string, editModal: HTMLDivElement) {
		this.loadingScreen = createLoadingScreen();
		this.userId = userId;
		this.editModalDiv = editModal;
	}

	public addDeleteModalClickListener() {
		const deleteButton: HTMLButtonElement = document.querySelector('#update-user-modal #delete');
		deleteButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchDeleteModal();
		}
	}

	private fetchDeleteModal() {
		fetchDeleteUserModal(this.userId)
			.then((response: string) => {
				this.openDeleteModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openDeleteModal(modalHTMLString: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(modalDiv);

		const cancelButton: HTMLButtonElement = document.querySelector('#cancel');
		cancelButton.onclick = () => {
			modalDiv.remove();
		};

		const image: HTMLImageElement = document.querySelector('#delete-user-modal img[alt="close icon"]');

		image.onclick = () => {
			modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#delete-user-modal button:last-child');

		saveButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.deleteUser(modalDiv);
		}
	}

	private deleteUser(modalDiv: HTMLDivElement) {
		deleteUser(this.userId)
			.then(() => {
				modalDiv.remove();
				this.editModalDiv.remove();
				Mediator.emit("userCrudOperationFinished");
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
